import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Box} from "@mui/material";
import {Close as CloseIcon} from "@mui/icons-material";

const MyDialog = ({children, title, isOpen, close, actions, showCloseButton = false, isTitleCentered = true, narrow = false, disableEnforceFocus = false}) => {

  return (
      <Dialog
          open={isOpen}
          onClose={close}
          fullScreen={false}
          // Opt-out for dialogs hosting editors (e.g. TinyMCE) whose own popups
          // render outside this modal — without this the focus trap makes those
          // popups/dialogs (link, image, source code) unusable.
          disableEnforceFocus={disableEnforceFocus}
          sx={{
            "& .MuiDialog-paper": {
              minWidth: narrow ? { xs: "95%", md: "420px" } : { xs: "95%", md: "70%" },
              maxWidth: narrow ? { xs: "95%", md: "450px" } : { xs: "95%", md: "90%" },
              maxHeight: { xs: "90vh", md: "85vh" },
              borderRadius: { xs: "12px", md: "14px" },
              margin: { xs: "16px", md: "32px" }
            }
          }}
      >
        <DialogTitle sx={{
          fontWeight: 600,
          fontSize: "20px",
          color: "#1F2937",
          padding: "20px 24px",
          borderBottom: "1px solid #E2E8F0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <Box sx={{display: "flex", alignItems: "center", width: "100%"}}>
            <Box sx={{flex: 1, textAlign: isTitleCentered ? "center" : "start"}}>
              {title}
            </Box>
            {showCloseButton && (
              <IconButton
                onClick={close}
                sx={{
                  color: "#6B7280",
                  "&:hover": {
                    backgroundColor: "rgba(107, 114, 128, 0.1)"
                  }
                }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </Box>
        </DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions sx={{padding: "16px 24px", borderTop: "1px solid #E2E8F0"}}>
          {actions}
        </DialogActions>
      </Dialog>
    // <Backdrop
    //     onClick={close}
    //     open={isOpen} sx={{zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    //   <Card sx={{minWidth: "618px"}} onClick={e => e.stopPropagation()}>
    //     <CardContent sx={{backgroundColor: "#57837E"}}>
    //       <Box sx={{display: "flex", alignItems: "center",
    //         justifyContent: "space-between",
    //         marginLeft: "28px",}}>
    //         <Typography sx={{marginLeft: "180px",
    //           fontWeight: 600,
    //           fontSize: "28px",
    //           lineHeight: "136.02%",
    //           color: "white"
    //         }}>{title}</Typography>
    //         <Box sx={{cursor: "pointer"}} onClick={close}>
    //           <CloseIcon/>
    //         </Box>
    //       </Box>
    //     </CardContent>
    //     {children}
    //   </Card>
    // </Backdrop>
  );
};

export default MyDialog;
